import Vue from 'vue'
import Vuex from 'vuex'
import { getUser } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: getUser() || '{}',
    routes: [],
    addRouterFlag: false
  },
  getters: {},
  mutations: {
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROUTES (state, routes) {
      state.routes = routes
    },
    SET_ADDROUTERFLAG (state, flag) {
      state.addRouterFlag = flag
    }
  },
  actions: {},
  modules: {}
})
